import SignText from '../../components/signtext/SignText'
import ResetPasswordForm from '../../components/forms/ResetPasswordForm'

const ResetPassword = () => {
    return (
        <div className='flex-center h-[100vh] overflow-hidden'>
            <SignText />
            <ResetPasswordForm />
        </div>
    )
}

export default ResetPassword